module.exports = __webpack_public_path__ + "6ff70ec11c0cb265cda8fb83e60284ed.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/widget-icons/target.png
// module id = 3046
// module chunks = 0